import React,{useState} from "react";
import axiosInstance from '../AxiosInstance';
import SidebarLayout from '../SidebarLayout';
import { Container, Button } from '@mui/material';

import CourseRecordSearchForm from "./CourseRecordSearchForm";

const CourseRecordMain=()=>{
    const [date,setDate]=useState(null);

    const handleRecord = () => {
        const token = localStorage.getItem('token');
        const authHeader = 'Bearer ' + token;
        const closeCourseDate = date; // 确保 `date` 变量有值
    
        axiosInstance.post(`/closecourse/${closeCourseDate}`, {}, {
            headers: { Authorization: authHeader }
        }).then(response => {
            console.log(response.data);
        }).catch(error => {
            console.error(error);
        });
    };
    
    return(
        <SidebarLayout>
            <Container maxWidth="lg" sx={{mt:4,mb:4}}>
                <CourseRecordSearchForm
                date={date}
                setDate={setDate}
                handleRecord={handleRecord}>

                </CourseRecordSearchForm>
            </Container>
        </SidebarLayout>
    )
};

export default CourseRecordMain;